export class Language {
    public UserId: number;
    public Lang: string;
}
